/* eslint-disable react/no-unescaped-entities */
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Link } from '@remix-run/react';
import { useLoaderData } from '@remix-run/react';
import { IframeModal } from '~/content/components/Modal/IframeModal';
import {
	Grid,
	Card,
	CardContent,
	IconButton,
	useMediaQuery,
	Divider,
	Button,
	Typography,
	Box,
	List,
	Avatar,
	ImageList,
	ImageListItem,
	ListItem,
	ListItemText,
	ListItemAvatar,
	CardActions,
	ToggleButtonGroup,
	ToggleButton,
	Skeleton,
	TextField,
	Checkbox,
	CircularProgress,
	FormHelperText,
	FormHelperTextProps,
	FormGroup,
	FormControlLabel,
	FormControl,
	OutlinedInput,
	InputAdornment,
	LinearProgress,
	MenuItem,
} from '@mui/material';

const HeroInfo = (): JSX.Element => {
	const { userLanguage } = useLoaderData();
	const link_prefix = userLanguage === 'en' ? '/en' : '';
	let { t } = useTranslation(['project_md-app']);
	const theme = useTheme();
	const isXs = useMediaQuery(theme.breakpoints.up('xs'), {
		defaultMatches: true,
	});
	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});

	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	return (
		<>
			<IframeModal
				open={open}
				handleClose={handleClose}
				handleOpen={handleOpen}
				// Then parse these -> username=DemoUser password=DEMO!123DEMO
				URL='https://app.demo.pre-release.md.hr-monitor.software?demo=U3RhcnRUaGVTeXN0ZW0'
				headline='2'
				id={undefined}
			/>
			<Grid item container columnSpacing={2}>
				<Grid item xs={12} lg={4} pr={6} ml={isMd ? 1.5 : 0} mt={isSm ? 1.5 : 2}>
					<Typography variant={'h5'} component='h2' align={'left'} mb={0.5} fontWeight={700}>
						{t('info_1')}
					</Typography>
					<Typography component='p' align={'left'}>
						{t('info_1_content')}
					</Typography>
				</Grid>
				<Divider orientation='vertical' flexItem />
				<Grid item xs={12} lg={'auto'} pr={6} ml={isMd ? 1.5 : 0} mt={isSm ? 1.5 : 2}>
					<Typography variant={'h5'} component='h2' align={'left'} mb={0.5} fontWeight={700}>
						{t('info_2')}
					</Typography>
					<Typography component='p' align={'left'}>
						{t('info_2_content')}
					</Typography>
				</Grid>
				<Divider orientation='vertical' flexItem />

				<Grid item xs={12} lg={'auto'} pr={6} ml={isMd ? 1.5 : 0} mt={isSm ? 1.5 : 2}>
					<Typography variant={'h5'} component='h2' align={'left'} mb={0.5} fontWeight={700}>
						{t('info_3')}
					</Typography>
					<Typography component='p' align={'left'}>
						{t('info_3_content')}
					</Typography>
				</Grid>

				<Divider orientation='vertical' flexItem />
				{/* <Divider orientation={isSm ? 'horizontal' : 'vertical'} flexItem /> */}

				<Grid
					item
					mt={isMd ? 0 : 3.5}
					xs={12}
					lg={'auto'}
					ml={isMd ? 1.5 : 0}
					sx={{
						// display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						display: isSm ? 'flex' : 'none',
					}}
				>
					{/* <Link
						to={'https://app.demo.pre-release.md.hr-monitor.software?demo=U3RhcnRUaGVTeXN0ZW0'}
						target='_blank'
						prefetch='none'
						style={{
							textDecoration: 'none',
						}}
						onClick={(e) => {
							e.stopPropagation();
							// e.preventDefault();
						}}
					> */}
					<Button
						component={'div'}
						size={'medium'}
						onClick={handleOpen}
						// change  font color
						// color={theme.palette.mode === "light" ? "primary" : "primary"}
						color={'primary'}
						variant='outlined'
					>
						{t('info_link_text')}{' '}
						<Box
							component={'span'}
							sx={{
								position: 'relative',
								width: '24px',
								display: 'inline-block',
								top: '3px',
								left: '5px',
							}}
						>
							<Box
								component={'svg'}
								xmlns='http://www.w3.org/2000/svg'
								viewBox='0 0 48 48'
								fill='#FF6600'
								stroke='#FF6600'
								width={20}
								height={20}
							>
								<path d='M10 38V26h3v9h9v3Zm25-16v-9h-9v-3h12v12Z'></path>
							</Box>
						</Box>
					</Button>
					{/* </Link> */}
				</Grid>
			</Grid>
		</>
	);
};

export default HeroInfo;
